
import {
  Component, PropSync, Prop, Mixins,
} from 'vue-property-decorator';
import { cancelPickup } from '@/features/pickup-history/services/pickupHistory.services';
import { GlobalResponseType } from '@/features/common/types';
import { showSuccessAlertDialog } from '@/features/common/helpers';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class CancelPickupModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) pickupId!: number;

  private loading = false;

  private cancelPickupResponse: GlobalResponseType | null = null;

  private async cancelPickup() {
    this.loading = true;

    this.cancelPickupResponse = await cancelPickup(this.pickupId);

    this.syncedShow = false;

    if (this.cancelPickupResponse && this.cancelPickupResponse.successful) {
      showSuccessAlertDialog(this.$t('pickupHistory.cancelPickup.successfulAlert') as string);
    }

    this.loading = false;
    this.$emit('cancelPickup', this.cancelPickupResponse);
  }
}
